import { useContext } from 'react';
import { AppConstants } from '@/context/AppConstants';
import { Text, Stack, Icons, Button, Box } from '@/theme/index';
import { useScreenSize } from '@/utils/useScreenSize';

interface PremiumDataCtaProps {
  isSection: boolean;
  sectionName?: string;
  nmvtisSuccess: boolean | undefined;
  reportUpgraded: boolean;
  handleFreeUpgrade: () => void;
}
export const PremiumDataCta = ({
  isSection,
  sectionName,
  nmvtisSuccess,
  reportUpgraded,
  handleFreeUpgrade,
}: PremiumDataCtaProps) => {
  const {
    images: { imgPremiumBadge },
  } = useContext(AppConstants);
  const { isMobile } = useScreenSize();

  return (
    <Stack mb={isSection ? 2.5 : 0}>
      <Stack
        direction={isMobile ? 'column' : 'row'}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{
          backgroundColor: 'secondary.main',
        }}
      >
        {!isSection && (
          <Box
            mb={isMobile ? 2 : 0}
            mr={isMobile ? 0 : 2}
            data-testid="premium-data-cta-image"
          >
            <img src={imgPremiumBadge} alt="Premium Data" />
          </Box>
        )}
        <Stack direction="column" sx={{ width: { sm: '100%', md: '50%' } }}>
          <Text
            variant="body1"
            sx={{ mb: 1 }}
            data-testid="premium-data-cta-title"
          >
            {!isSection ? (
              'Additional information may be available.'
            ) : (
              <strong>{`${sectionName} information`}</strong>
            )}{' '}
            may be available from our <strong>premium sources</strong>
          </Text>
          <Text
            variant="body1"
            sx={{ mb: 2 }}
            data-testid="premium-data-cta-body"
          >
            {!isSection
              ? 'Premium Data may include NMVTIS title and salvage records.'
              : `Upgrade this whole report for FREE to premium to search for ${sectionName} information. Premium Data may include NMVTIS title and salvage records.`}
          </Text>
        </Stack>
        <Button
          variant="contained"
          onClick={handleFreeUpgrade}
          color="success"
          data-testid="premium-data-cta-button"
        >
          View FREE premium data
        </Button>
      </Stack>
      {reportUpgraded && !nmvtisSuccess && (
        <Text
          variant="h5"
          color="error"
          display="flex"
          alignItems="center"
          m={0}
          mt={1}
        >
          <Icons.Warning color="error" fontSize="small" sx={{ mr: 1 }} />
          Report upgrade failed. Please try again.
        </Text>
      )}
    </Stack>
  );
};
